import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { ArrowLeft, Palette, Mail, FileText, Settings, Coins, ScrollText, Sparkles, Clock } from 'lucide-react';
import BrandingTab from '../../components/admin/BrandingTab';
import EmailTemplatesTab from '../../components/admin/EmailTemplatesTab';
import FormDocumentsTab from '../../components/admin/FormDocumentsTab';
import SystemSettingsTab from '../../components/admin/SystemSettingsTab';
import CurrencyRatesTab from '../../components/admin/CurrencyRatesTab';
import MaintenanceTab from '../../components/admin/MaintenanceTab';
import TermsOfServiceTab from '../../components/admin/TermsOfServiceTab';
import WhatsNewTab from '../../components/admin/WhatsNewTab';
import SaleWindowTab from '../../components/admin/SaleWindowTab';

const SystemConfigPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultTab = new URLSearchParams(location.search).get('tab') || 'branding';

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-primary text-white px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => navigate('/admin/system')}
            className="text-white hover:bg-white/20"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="font-serif text-xl font-semibold">System Configuration</h1>
            <p className="text-xs text-white/70">Platform-wide settings and templates</p>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto p-6">
        <Tabs defaultValue={defaultTab} className="space-y-6">
          <TabsList>
            <TabsTrigger value="currencies">
              <Coins className="w-4 h-4 mr-2" /> Currency Rates
            </TabsTrigger>
            <TabsTrigger value="branding">
              <Palette className="w-4 h-4 mr-2" /> Branding
            </TabsTrigger>
            <TabsTrigger value="email-templates">
              <Mail className="w-4 h-4 mr-2" /> Email Templates
            </TabsTrigger>
            <TabsTrigger value="forms">
              <FileText className="w-4 h-4 mr-2" /> Form Documents
            </TabsTrigger>
            <TabsTrigger value="system">
              <Settings className="w-4 h-4 mr-2" /> Email Settings
            </TabsTrigger>
            <TabsTrigger value="maintenance">
              <Settings className="w-4 h-4 mr-2" /> Maintenance
            </TabsTrigger>
            <TabsTrigger value="terms">
              <ScrollText className="w-4 h-4 mr-2" /> Terms of Service
            </TabsTrigger>
            <TabsTrigger value="whats-new">
              <Sparkles className="w-4 h-4 mr-2" /> What's New
            </TabsTrigger>
            <TabsTrigger value="sale-window">
              <Clock className="w-4 h-4 mr-2" /> Sale Window
            </TabsTrigger>
          </TabsList>

          {/* Currency Rates Tab */}
          <TabsContent value="currencies">
            <CurrencyRatesTab />
          </TabsContent>

          {/* Branding Tab */}
          <TabsContent value="branding">
            <BrandingTab />
          </TabsContent>

          {/* Email Templates Tab */}
          <TabsContent value="email-templates">
            <EmailTemplatesTab />
          </TabsContent>

          {/* Form Documents Tab */}
          <TabsContent value="forms">
            <FormDocumentsTab />
          </TabsContent>

          {/* System Settings Tab */}
          <TabsContent value="system">
            <SystemSettingsTab />
          </TabsContent>

          {/* Maintenance Tab */}
          <TabsContent value="maintenance">
            <MaintenanceTab />
          </TabsContent>

          {/* Terms of Service Tab */}
          <TabsContent value="terms">
            <TermsOfServiceTab />
          </TabsContent>

          {/* What's New Tab */}
          <TabsContent value="whats-new">
            <WhatsNewTab />
          </TabsContent>

          <TabsContent value="sale-window">
            <SaleWindowTab />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default SystemConfigPage;
